import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

declare global {
  interface Window {
    endorsely_referral?: string;
  }
}

export function useReferralTracking() {
  useEffect(() => {
    // Check if there's a referral ID from Endorsely
    const checkReferralId = () => {
      const referralId = window.endorsely_referral;
      
      if (referralId) {
        console.log('Referral ID detected:', referralId);
        // Store in localStorage for later use
        localStorage.setItem('endorsely_referral', referralId);
      }
    };

    // Check immediately
    checkReferralId();

    // Also check after a short delay to ensure the script has loaded
    const timer = setTimeout(checkReferralId, 1000);

    return () => clearTimeout(timer);
  }, []);

  const trackConversion = async (email: string, amount?: number, name?: string, customerId?: string) => {
    const referralId = localStorage.getItem('endorsely_referral');
    
    if (!referralId) {
      console.log('No referral ID found, skipping tracking');
      return;
    }

    try {
      const { data, error } = await supabase.functions.invoke('track-referral', {
        body: {
          referralId,
          email,
          amount,
          name,
          customerId
        }
      });

      if (error) {
        console.error('Error tracking referral:', error);
      } else {
        console.log('Referral tracked successfully:', data);
      }
    } catch (err) {
      console.error('Exception tracking referral:', err);
    }
  };

  return { trackConversion };
}
